export default __webpack_public_path__ + "static/media/linelogo.255c30bc.png";